module.exports = __webpack_public_path__ + "static/media/LectureSeriesImg4.bb60be28.PNG";